// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__FExYW","loader":"Loader_loader__zOdzA","animloader":"Loader_animloader__yy0c7","animloader2":"Loader_animloader2__+znc1"};